import { useState } from "react";
import { Button, Card, Input, Stack, Text } from "@/components/ui";
import { useCambiarNombre } from "../hooks/use-usuarios-mutations";

/**
 * Editor del nombre (FullName) del usuario. State local para permitir escribir
 * y guardar con un click · el botón se deshabilita si no hay cambios respecto
 * al valor actual (trim). Vacío = sin nombre.
 */
export function SeccionNombre({
  usuarioId,
  nombreActual,
  email,
}: {
  usuarioId: string;
  nombreActual: string | null;
  email: string;
}) {
  const [valor, setValor] = useState(nombreActual ?? "");
  const guardar = useCambiarNombre();

  const normalizado = valor.trim();
  const sinCambios = normalizado === (nombreActual ?? "").trim();

  return (
    <Card padding="md">
      <Stack gap="sm">
        <Text size="xs" fw={600} className="uppercase tracking-wide" c="dimmed">
          Nombre
        </Text>
        <Input
          size="sm"
          value={valor}
          onChange={(e) => setValor(e.currentTarget.value)}
          placeholder={email}
          aria-label="Nombre del usuario"
          maxLength={200}
        />
        <Button
          size="xs"
          fullWidth
          loading={guardar.isPending}
          disabled={sinCambios}
          onClick={() => guardar.mutate({ usuarioId, fullName: normalizado === "" ? null : normalizado })}
        >
          Guardar nombre
        </Button>
      </Stack>
    </Card>
  );
}
